import { FC } from 'react';
import {
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  UseDisclosureReturn,
} from '@chakra-ui/react';

import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import TimelinePresentation from 'features/Onboarding/components/TimelinePresentation';

import locales from './locales';

const MoreDetailsModal: FC<UseDisclosureReturn> = (props) => (
  <Modal {...props} scrollBehavior="inside">
    <ModalOverlay />
    <ModalContent
      alignSelf={{ base: 'flex-end', md: 'center' }}
      borderBottomRadius={{ base: 0, md: 'radius-8' }}
      borderTopRadius={{ base: 'radius-16', md: 'radius-8' }}
      marginY={{ base: 0, md: '3.75rem' }}
    >
      <ModalBody className="ModalBody">
        <TimelinePresentation
          description={locales.description}
          marginY="space-40"
          steps={[
            {
              description: locales.steps.info.description,
              icon: <SquircleIcon name="shield" />,
              title: locales.steps.info.title,
            },
            {
              description: locales.steps.transfer.description,
              extraContent: (
                <Link
                  href="https://help.shine.fr/fr/articles/3396199-qu-est-ce-que-l-attestation-de-depot-de-capital"
                  marginBottom="space-16"
                  target="_blank"
                >
                  {locales.steps.transfer.link}
                </Link>
              ),
              icon: <SquircleIcon name="euro" />,
              title: locales.steps.transfer.title,
            },
            {
              description: locales.steps.statutes.description,
              extraContent: (
                <Link
                  href="https://help.shine.fr/fr/articles/3074930-quelles-sont-les-differentes-etapes-avant-d-obtenir-mon-attestation-de-depot-de-capital"
                  marginBottom="space-16"
                  target="_blank"
                >
                  {locales.steps.statutes.link}
                </Link>
              ),
              icon: <SquircleIcon name="company" />,
              title: locales.steps.statutes.title,
            },
            {
              description: locales.steps.accountOpened.description,
              icon: <SquircleIcon name="unlock" />,
              title: locales.steps.accountOpened.title,
            },
          ]}
          title={locales.title}
        />
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default MoreDetailsModal;
